import type { EnvConfig } from '@weberus/feature-flag';
import type { FeatureFlagKey } from '@/conf/feature-flag-config';
import { FeatureFlagService } from '@weberus/feature-flag';

import { featureFlagsConfig } from '@/conf/feature-flag-config';

/**
 * promote-site에서 사용하는 feature flag를 확인하는 함수
 *
 * @param featureName - feature flag key
 * @returns feature flag가 활성화되어 있는지 여부
 */
export const isFeatureEnabled = (featureName: FeatureFlagKey) => {
  const featureFlagService = new FeatureFlagService(
    featureFlagsConfig,
    process.env.NEXT_PUBLIC_SERVICE_ENV as keyof EnvConfig,
  );

  return featureFlagService.isFeatureEnabled(featureName);
};
